module.exports = __webpack_public_path__ + "img/monitor.3e4614fd.jpg";